import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';

export const NotFound404 = () => {
  return (
    <div style={{ padding: '16px', textAlign: 'center' }}>
      <Typography variant="h4">404 Not Found</Typography>
    </div>
  );
};